import { defineStore } from 'pinia'
import { login as loginRequest, me as meRequest, logout as logoutRequest } from '@/services/authService'
import { ROLES, ROLE_REDIRECT } from '@/permissions/roles'

function mapEmployee(employee, bearer_token) {
  return {
    id:           employee.id,
    name:         employee.full_name,
    email:        employee.email,
    employee_code: employee.employee_code,
    photo_url:    employee.photo_url ?? null,
    role:         employee.role_name,
    hotel_id:     employee.hotel_id ?? null,
    hotel:        employee.hotel_name ?? null,
    is_dev:       employee.is_dev ?? false,
    bearer_token,
  }
}

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: JSON.parse(localStorage.getItem('user') ?? 'null'),
  }),

  getters: {
    isAuthenticated: (state) => !!state.user,
    role:    (state) => state.user?.role    ?? null,
    hotelId: (state) => state.user?.hotel_id ?? null,
    isDev:   (state) => state.user?.is_dev   ?? false,
  },

  actions: {
    async login(identifier, password) {
      const { data } = await loginRequest(identifier, password)
      const user = mapEmployee(data.employee, data.bearer_token)
      this.user = user
      localStorage.setItem('user', JSON.stringify(user))
      return ROLE_REDIRECT[user.role] ?? '/dashboard'
    },

    // Limpa o estado LOCAL de forma síncrona (sem await antes/depois nas duas
    // linhas abaixo) -- AppLayout.vue::handleLogout depende disso pra evitar
    // a tela branca pós-logout (a página protegida ainda montada não pode
    // ter a chance de re-renderizar com auth nulo antes do redirect). A
    // chamada ao backend pra encerrar a sessão (staff_sessions, múltiplas
    // sessões) é best-effort e não deve atrasar nem quebrar o logout local
    // -- captura o token ANTES de limpar (ver comentário em
    // authService.logout) e segue mesmo se a chamada falhar.
    logout() {
      const token = this.user?.bearer_token
      this.user = null
      localStorage.removeItem('user')
      if (token) logoutRequest(token).catch(() => { /* best-effort */ })
    },

    async refreshUser() {
      if (!this.user) return
      try {
        const { data } = await meRequest()
        const user = mapEmployee(data, this.user.bearer_token)
        this.user = user
        localStorage.setItem('user', JSON.stringify(user))
      } catch { /* mantém os dados locais se a chamada falhar */ }
    },
  },
})
